import { useDispatch, useSelector } from "react-redux";
import {
  setContainsBlockRackNonLGV,
  setResultMessage,
  setResults,
  setSelectedResult,
} from "../../store/inventorySlice";
import { useEffect } from "react";
import { isFiltersEnabled, matches } from "./utils";
import { Virtuoso } from "react-virtuoso";

const Result = () => {
  const dispatch = useDispatch();
  const { results, resultMessage } = useSelector((state) => state.inventory);
  const {
    filters: {
      lpn: selectedLPN,
      location: selectedLocation,
      sku: selectedSKU,
      qualityStatus: selectedQualityStatus,
    },
    items: { blocks, racks, nonLGV, lgvs },
  } = useSelector((state) => state.inventory);

  //Result yielding logic
  useEffect(() => {
    if (!isFiltersEnabled()) return;

    const locationMap = new Map();
    let hasInventoryStorage = false;
    [...blocks, ...racks, ...nonLGV, ...lgvs].forEach(
      ({
        location,
        latitude,
        longitude,
        storageType,
        sku,
        lpn,
        qualityStatus,
        positionLength,
        locationOrientation,
        vehicleNumber,
      }) => {
        if (
          matches(
            { location, sku, lpn, qualityStatus, vehicleNumber },
            {
              selectedLPN,
              selectedLocation,
              selectedSKU,
              selectedQualityStatus,
            }
          )
        ) {
          if (!hasInventoryStorage && storageType !== "lgv")
            hasInventoryStorage = true;

          if (!locationMap.has(location)) {
            locationMap.set(location, {
              location,
              latitude,
              longitude,
              storageType,
              positionLength,
              locationOrientation,
            });
          }
        }
      }
    );

    const resultList = Array.from(locationMap.values());
    dispatch(setResults(resultList));
    dispatch(setResultMessage(resultList.length ? "" : "No matches found!"));
    dispatch(setContainsBlockRackNonLGV(hasInventoryStorage));
  }, [selectedLPN, selectedLocation, selectedQualityStatus, selectedSKU]);

  return (
    <div
      className="result-section-wrapper"
      style={
        results.length
          ? {}
          : {
              alignItems: "center",
              justifyContent: "center",
            }
      }
    >
      {results.length ? (
        <Virtuoso
          style={{ height: "100%", width: "100%" }}
          totalCount={results?.length}
          itemContent={(index) => {
            const item = results[index];
            return (
              <div
                key={item.location}
                className="result"
                onClick={() => dispatch(setSelectedResult(item))}
              >
                {item.location}
              </div>
            );
          }}
        />
      ) : (
        <div className="result-message">
          {resultMessage ? resultMessage : "Apply filters to see the results!"}
        </div>
      )}
    </div>
  );
};

export default Result;
